// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Edge$YourProjectName from "./edge/edge.bs.js";
import * as Fill$YourProjectName from "./fill/fill.bs.js";
import * as Tikz$YourProjectName from "./tikz.bs.js";
import * as AppState$YourProjectName from "./appState.bs.js";
import * as Previewer$YourProjectName from "./previewer/previewer.bs.js";
import * as Coordinate$YourProjectName from "./coordinate/coordinate.bs.js";
import * as RemoveName$YourProjectName from "./removeName.bs.js";
import * as EdgeSelector$YourProjectName from "./selector/edgeSelector.bs.js";
import * as FillSelector$YourProjectName from "./selector/fillSelector.bs.js";
import * as CoordinateSelector$YourProjectName from "./selector/coordinateSelector.bs.js";

require("./app.css");

function App(Props) {
  var match = React.useState(function () {
        return {
                mode: /* Neutral */0,
                scale: 50,
                svgx: 500,
                svgy: 300,
                namePool: AppState$YourProjectName.NamePool.empty,
                coordinates: CoordinateSelector$YourProjectName.empty,
                edges: EdgeSelector$YourProjectName.empty,
                fills: FillSelector$YourProjectName.empty
              };
      });
  var setState = match[1];
  var state = match[0];
  return React.createElement("div", {
              id: "app"
            }, React.createElement("h1", undefined, "Oekaki"), React.createElement("div", {
                  id: "output"
                }, React.createElement(Previewer$YourProjectName.make, {
                      state: state
                    }), React.createElement(Tikz$YourProjectName.make, {
                      state: state
                    })), React.createElement("div", {
                  id: "selectors"
                }, React.createElement(CoordinateSelector$YourProjectName.make, {
                      cs: state.coordinates
                    }), React.createElement(EdgeSelector$YourProjectName.make, {
                      cs: state.edges
                    }), React.createElement(FillSelector$YourProjectName.make, {
                      cs: state.fills
                    })), React.createElement("div", {
                  id: "message"
                }, "message: "), React.createElement(RemoveName$YourProjectName.make, {
                  updater: (function (param) {
                      return AppState$YourProjectName.remove(setState, param);
                    })
                }), React.createElement(Coordinate$YourProjectName.Add.make, {
                  updater: (function (param, param$1, param$2) {
                      return AppState$YourProjectName.addCoordinate(setState, param, param$1, param$2);
                    })
                }), React.createElement(Edge$YourProjectName.Add.make, {
                  updater: (function (param, param$1, param$2, param$3, param$4) {
                      return AppState$YourProjectName.addEdge(setState, param, param$1, param$2, param$3, param$4);
                    })
                }), React.createElement(Fill$YourProjectName.Add.make, {
                  updater: (function (param, param$1, param$2) {
                      return AppState$YourProjectName.addFill(setState, param, param$1, param$2);
                    })
                }));
}

var R;

var RR;

var make = App;

export {
  R ,
  RR ,
  make ,
  
}
/*  Not a pure module */
